/*
  If there are any environment params that need to be added to '/config/{ENV}.js' files
*/

module.exports = {
  deviceIdDomain: '.crunchyroll.com',
  deviceType: 'com.crunchyroll.static',
  accessToken: 'giKq5eY27ny3cqz',
  duration: '999999',
  projectName: 'cr-spa-registration',
  authorizedRoutes: [
    '/success',
    '/complete',
    '/billing-plans',
    '/already-premium',
    '/success-nextlevel',
    '/pricing-promo-success',
  ],
  availableRoutes: [
    '/',
    '/success',
    '/billing-plans',
    '/login',
    '/register',
    '/error',
    '/unavailable',
    '/complete',
    '/already-premium',
    '/nextlevel',
    '/success-nextlevel',
    '/registration-premium-prompt',
    '/pricing-promo',
    '/pricing-promo-success',
  ],
  newsServiceUrl: 'https://cr-news-api-service.stg.crunchyrollsvc.com/v1',
  cxApiParams: {
    host: 'https://beta-stage-api.crunchyroll.com',
    accountAuthClientId: 'pjsldbnxqaaytvfl7box',
    anonClientId: 'cr_web',
  },
  analytics: {
    defaultApiHost: 'cr-eec.etp-staging.com/v1',
    writeKey: 'bmeXq8x8muZC8wdIBwH5dPnfeErtJM2r',
    fallbackLibraryHost: 'sa.etp-staging.com/analytics.js/v1/',
    domain: 'crunchyroll',
    analyticsScriptSrc:
      'https://static.crunchyroll.com/analytics/cr-eec-8.1.0.js',
    gtmId: 'GTM-PK7T4JG',
  },
  ccpa: {
    userConsentConfig: {
      cookieDomain: '.crunchyroll.com',
      domId: '5ab43da4-d954-44e8-9dd6-94f6f99ea2a5-test',
      src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
    },
  },
  feature_cookie_name: 'efg_state',
  oneTrust: {
    sdkSrc: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
    domainScript: '9470b86f-5b87-4646-a4f7-2f2916b2a883-test',
  },
};
